import React from 'react';
import MovieButton from '../atom/MovieButton';
import ContactMessage from '../atom/ContactMessage';
import CompanyInfoText from '../atom/CompanyInfoText';
import Ralsnet from '../atom/Ralsnet';
import styles from './Footer.module.scss';

const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <div className={styles.footer__contact}>
      <MovieButton />
      <ContactMessage />
      <CompanyInfoText />
    </div>
    <Ralsnet />
  </footer>
);

export default Footer;
